import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";
// import { BaseCartLineConnectionMasked_Fragment } from "./base-cart-line-connection";

export const Cart_Fragment = graphqlShopifyStorefront(
  `
  fragment Cart on Cart {
    id
    checkoutUrl
    cost {
      subtotalAmount {
        amount
        currencyCode
      }
      totalAmount {
        amount
        currencyCode
      }
    }
    baseCartLineConnectionMasked: lines(first: 32) {
      ...BaseCartLineConnectionMasked
    }
    totalQuantity
  }
`,
  // [BaseCartLineConnectionMasked_Fragment],
);
